<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">รายการโควต้าบัตร</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ดูโควต้าที่อนุมัติแล้ว — คงเหลือ / ใช้ไปแล้ว / แจกแล้ว</p>
      <p *ngIf="clientScope.isRestricted()" class="text-xs text-amber-700 dark:text-amber-400 mt-2 flex items-center gap-1">
        <span class="material-icons text-sm">store</span>
        แสดงเฉพาะโควต้าร้าน: <span class="font-bold">{{ clientScope.scopeSummaryLabel() }}</span>
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div class="relative min-w-[200px]">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-amber-500 text-[20px]">place</span>
        <select *ngIf="siteState.sites().length > 1" [ngModel]="selectedSiteId" (ngModelChange)="onSiteChange($event)"
          class="w-full pl-10 pr-4 py-2.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 text-sm font-bold rounded-xl text-slate-800 dark:text-amber-100 outline-none focus:ring-2 focus:ring-amber-200 h-[46px]">
          <option *ngFor="let site of siteState.sites()" [ngValue]="site.id">{{ site.name }}</option>
        </select>
        <div *ngIf="siteState.sites().length <= 1"
          class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-100 dark:border-slate-700 text-sm font-bold rounded-xl text-slate-700 dark:text-slate-200 h-[46px] flex items-center">
          {{ siteState.selectedSite()?.name || '—' }}
        </div>
      </div>
      <button (click)="onRefresh()"
        class="p-3 bg-white/95 dark:bg-slate-900/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 hover:text-amber-500 transition-all flex items-center justify-center h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/50 flex flex-col gap-4">
      <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">confirmation_number</span>
          โควต้าที่อนุมัติแล้ว
          <span class="text-xs font-semibold text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
            {{ siteState.selectedSite()?.name || '—' }}
          </span>
        </h3>
        <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:max-w-3xl">
          <select [ngModel]="searchField()" (ngModelChange)="searchField.set($event)"
            class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option *ngFor="let opt of searchFieldOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
          <div class="relative flex-1 flex">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
            <input type="text" placeholder="ค้นหา..." [ngModel]="searchText()"
              (ngModelChange)="searchText.set($event)" (keyup.enter)="onSearch()"
              class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none">
          </div>
          <button (click)="onSearch()"
            class="px-4 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl transition-all">ค้นหา</button>
          <button *ngIf="searchText()" (click)="clearSearchText()"
            class="px-4 py-2.5 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 font-bold rounded-xl transition-all">ล้าง</button>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row sm:items-end gap-3">
        <div class="flex-1">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">กรองเพิ่มเติม (เลือกได้อย่างใดอย่างหนึ่ง)</label>
          <select [ngModel]="secondaryFilterMode()" (ngModelChange)="onSecondaryFilterModeChange($event)"
            class="w-full sm:w-56 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option value="">ไม่กรอง</option>
            <option value="level">ตาม Level</option>
            <option value="status">ตามสถานะ</option>
          </select>
        </div>
        <div *ngIf="secondaryFilterMode() === 'level'" class="flex-1">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">Level</label>
          <select [ngModel]="filterQuotaLevel()" (ngModelChange)="onLevelChange($event)"
            class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option *ngFor="let opt of levelOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div *ngIf="secondaryFilterMode() === 'status'" class="flex-1">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">สถานะ</label>
          <select [ngModel]="filterQuotaStatus()" (ngModelChange)="onStatusChange($event)"
            class="w-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-bold px-3 py-2.5 outline-none focus:ring-2 focus:ring-amber-200">
            <option *ngFor="let opt of statusOptions" [value]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-900/95 border-b border-slate-100/50">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">ชื่อโควต้า</th>
            <th class="p-4">ลาน</th>
            <th class="p-4 text-center">Level</th>
            <th class="p-4 text-center">Approved</th>
            <th class="p-4 text-center">Used</th>
            <th class="p-4 text-center">Allocated</th>
            <th class="p-4 text-center">คงเหลือ</th>
            <th class="p-4 text-center">สถานะ</th>
            <th class="p-4 text-center w-[100px]">ดู</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-800">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all cursor-pointer" (click)="openDetail(item)">
            <td class="p-4 font-semibold text-slate-700 dark:text-slate-200">{{ item.name }}</td>
            <td class="p-4 text-sm text-slate-500">{{ item.siteName || siteState.selectedSite()?.name || '—' }}</td>
            <td class="p-4 text-center text-xs">{{ levelLabel(item.quotaLevel) }}</td>
            <td class="p-4 text-center font-medium">{{ item.quotaApproved }}</td>
            <td class="p-4 text-center">{{ item.quotaUsed }}</td>
            <td class="p-4 text-center">{{ item.quotaAllocated }}</td>
            <td class="p-4 text-center font-bold text-emerald-600">{{ item.quotaRemaining }}</td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                [ngClass]="{
                  'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400': item.quotaStatus === 'active',
                  'bg-rose-50 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400': item.quotaStatus === 'suspended',
                  'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400': item.quotaStatus === 'pending',
                  'bg-slate-100 text-slate-500 dark:bg-slate-800': item.quotaStatus !== 'active' && item.quotaStatus !== 'suspended' && item.quotaStatus !== 'pending'
                }">
                {{ statusLabel(item.quotaStatus) }}
              </span>
            </td>
            <td class="p-4 text-center" (click)="$event.stopPropagation()">
              <button (click)="openDetail(item)"
                class="w-8 h-8 rounded-lg flex items-center justify-center border border-slate-100 hover:border-amber-400 text-slate-400 hover:text-amber-500 transition-all">
                <span class="material-icons text-base">visibility</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="items().length === 0 && !isLoading()">
            <td colspan="9" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">search_off</span>
              <p class="font-bold">{{ selectedSiteId ? 'ไม่พบโควต้าในลานที่เลือก' : 'กรุณาเลือกลาน' }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/50 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 text-sm rounded-lg font-bold px-2 py-1 outline-none">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white' : 'text-slate-600 hover:bg-amber-50'">
          {{ page }}
        </button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 hover:text-amber-500 disabled:opacity-30">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>

<app-modal-client-quota-detail *ngIf="isDetailOpen()" [quotaId]="selectedQuotaId()"
  (close)="closeDetail()"></app-modal-client-quota-detail>
